import React from "react";
import { HiCheckCircle, HiArrowDownCircle } from "react-icons/hi2";
import { useQuery } from "@tanstack/react-query";
import { getWalletTransactions } from "../../api/common/wallet";


function Wallet() {
    const { data: walletData, isLoading, isError } = useQuery({
        queryKey: ["wallet-transactions"],
        queryFn: getWalletTransactions,
    });




    if (isLoading) return;


    const { balance, transactions } = walletData?.data;

    return (
        <div className="p-6 lg:p-12 max-w-4xl mx-auto">
            {/* Wallet Header */}
            <div className="text-center mb-10">
                <h1 className="text-3xl font-semibold mb-2">Wallet</h1>
                <p className="text-gray-600">Available Balance</p>
                <div className="text-3xl font-bold text-blue-600 mt-1">
                    €{balance?.toFixed(2)}
                </div>

            </div>

            {/* Transaction History */}
            <div className="border rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-semibold mb-4">Transaction History</h3>

                {transactions.length === 0 ? (
                    <p className="text-gray-500 text-sm">No transactions found.</p>
                ) : (
                    <ul className="space-y-5">
                        {transactions.map((txn) => (
                            <li key={txn._id} className="flex justify-between items-center">
                                <div className="flex items-center gap-3">
                                    {txn.type === "credit" ? (
                                        <HiCheckCircle className="text-green-500 text-xl" />
                                    ) : (
                                        <HiArrowDownCircle className="text-yellow-500 text-xl" />
                                    )}
                                    <div>
                                        <p className="font-medium capitalize">{txn.reason}</p>
                                        <p className="text-sm text-gray-500">
                                            {new Date(txn.createdAt).toLocaleDateString()}
                                        </p>
                                    </div>
                                </div>
                                <p
                                    className={`font-semibold ${txn.type === "credit" ? "text-green-600" : "text-orange-500"
                                        }`}
                                >
                                    {txn.type === "debit" ? "-" : "+"}€{txn.amount.toFixed(2)}
                                </p>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default Wallet;
